import React, { useState, useEffect, useCallback } from 'react';
import { Navbar, Container, Nav, Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    const [isFooterVisible, setIsFooterVisible] = useState(false);

    const toggleFooter = () => {
        setIsFooterVisible(!isFooterVisible);
    };
    const [clickSound] = useState(new Audio('/sounds/coin.wav'));
    const defaultHelpers = [
        { id: 1, name: 'Imp', cost: 100, income: 1, count: 0, image: '/images/imp.png', positions: [] },
        { id: 2, name: 'Goblin', cost: 500, income: 5, count: 0, image: '/images/goblin.png', positions: [] },
        { id: 3, name: 'Chaos Factory', cost: 3000, income: 30, count: 0, image: '/images/factory.png', positions: [] },
        { id: 4, name: 'Witch', cost: 11000, income: 110, count: 0, image: '/images/witch.png', positions: [] },
        { id: 5, name: 'Demon', cost: 55000, income: 550, count: 0, image: '/images/demon.png', positions: [] },
        { id: 6, name: 'Warlock', cost: 250000, income: 2500, count: 0, image: '/images/warlock.png', positions: [] },
        { id: 7, name: 'Necromancer', cost: 1500000, income: 15000, count: 0, image: '/images/necromancer.png', positions: [] },
        { id: 8, name: 'Dragon', cost: 5500000, income: 55000, count: 0, image: '/images/dragon.png', positions: [] },
        { id: 9, name: 'Titan', cost: 25000000, income: 250000, count: 0, image: '/images/titan.png', positions: [] },
        { id: 10, name: 'Chaos God', cost: 150000000, income: 750000, count: 0, image: '/images/chaos-god.png', positions: [] },
        { id: 11, name: 'Elemental Spirit', cost: 1000000000, income: 5000000, count: 0, image: '/images/elemental-spirit.png', positions: [] },
        { id: 12, name: 'Timekeeper', cost: 5000000000, income: 25000000, count: 0, image: '/images/timekeeper.png', positions: [] },
        { id: 13, name: 'Meteorite Guardian', cost: 20000000000, income: 100000000, count: 0, image: '/images/meteorite-guardian.png', positions: [] },
        { id: 14, name: 'Omnipotent', cost: 400000000000, income: 2000000000, count: 0, image: '/images/omnipotent.png', positions: [] },
    ];

    const loadData = () => {
        const savedChaos = parseFloat(localStorage.getItem('chaos')) || 0;
        const savedHelpers = JSON.parse(localStorage.getItem('helpers')) || defaultHelpers;
        const savedChaosPerClick = parseFloat(localStorage.getItem('chaosPerClick')) || 1;
        return { savedChaos, savedHelpers, savedChaosPerClick };
    };


    const { savedChaos, savedHelpers, savedChaosPerClick } = loadData();

    const [chaos, setChaos] = useState(savedChaos);
    const [chaosPerClick, setChaosPerClick] = useState(savedChaosPerClick);
    const [helpers, setHelpers] = useState(savedHelpers);
    const [helperAnimations, setHelperAnimations] = useState([]);
    const [clickAnimations, setClickAnimations] = useState([]);
    const [lastUpdateTime, setLastUpdateTime] = useState(Date.now());
    const [showResetModal, setShowResetModal] = useState(false);
    const colors = ['#FF5733', '#33FF57', '#3357FF', '#FF33A1', '#FFD133'];

    const formatNumber = (value) => {
        return new Intl.NumberFormat('cs-CZ', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    const addClickAnimation = useCallback((x, y, value) => {
        const id = Date.now();
        const color = colors[Math.floor(Math.random() * colors.length)];
        setClickAnimations((prev) => [...prev, { id, x, y, value, color }]);
        setTimeout(() => {
            setClickAnimations((prev) => prev.filter((animation) => animation.id !== id));
        }, 1000);
    }, []);

    const addHelperAnimation = useCallback((x, y, value) => {
        const id = Date.now();
        const color = colors[Math.floor(Math.random() * colors.length)];
        setHelperAnimations((prev) => [...prev, { id, x, y, value, color }]);
        setTimeout(() => {
            setHelperAnimations((prev) => prev.filter((animation) => animation.id !== id));
        }, 1000);
    }, []);

    useEffect(() => {
        localStorage.setItem('chaos', chaos);
        localStorage.setItem('helpers', JSON.stringify(helpers));
        localStorage.setItem('chaosPerClick', chaosPerClick);
    }, [chaos, helpers, chaosPerClick]);

    useEffect(() => {
        const handleRightClick = (e) => {
            e.preventDefault(); // Zabraňuje zobrazení kontextového menu
        };

        document.addEventListener('contextmenu', handleRightClick);

        return () => {
            document.removeEventListener('contextmenu', handleRightClick);
        };
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            const now = Date.now();
            const elapsed = now - lastUpdateTime;
            setLastUpdateTime(now);

            setChaos((prevChaos) => {
                let income = 0;

                helpers.forEach((helper) => {
                    helper.positions.forEach((position) => {
                        income += helper.income * (elapsed / 1000);
                        addHelperAnimation(`${position.x}%`, `${position.y}%`, helper.income);
                    });
                });

                return prevChaos + income;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [helpers, lastUpdateTime, addHelperAnimation]);

    const handleClick = (event) => {
        clickSound.play();
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        setChaos((prevChaos) => prevChaos + chaosPerClick);
        addClickAnimation(`${x}px`, `${y}px`, chaosPerClick);
    };

    const upgradeClickValue = () => {
        const upgradeCost = Math.round(chaosPerClick * 100);
        if (chaos >= upgradeCost) {
            setChaos((prevChaos) => prevChaos - upgradeCost);
            setChaosPerClick((prevValue) => prevValue + 1);
        }
    };

    const buyHelper = (helper) => {
        if (chaos >= helper.cost) {
            const newPosition = { x: Math.random() * 90 + 5, y: Math.random() * 80 + 10 };

            setChaos((prevChaos) => prevChaos - helper.cost);
            setHelpers((prevHelpers) =>
                prevHelpers.map((h) =>
                    h.id === helper.id
                        ? {
                            ...h,
                            count: h.count + 1,
                            cost: Math.round(h.cost * 1.5),
                            positions: [...h.positions, newPosition],
                        }
                        : h
                )
            );
        }
    };

    const resetGame = () => {
        setChaos(0);
        setChaosPerClick(1);
        setHelpers(defaultHelpers);
        localStorage.clear();
        localStorage.setItem('chaos', 0);
        localStorage.setItem('chaosPerClick', 1);
        localStorage.setItem('helpers', JSON.stringify(defaultHelpers));
        setShowResetModal(false);
    };


    const helpersIncomePerSecond = helpers.reduce((acc, helper) => acc + helper.income * helper.count, 0);

    return (
        <div className="vh-100 d-flex flex-column"
             style={{backgroundImage: 'url(/images/background.jpg)', backgroundSize: 'cover'}}>
            <Navbar bg="dark" variant="dark" expand="lg">
                <Container>
                    <Navbar.Brand className="text-light"><img style={{height: 30}}
                                                              src="/images/logo.png"/></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Item className="d-flex align-items-center me-3 text-light">
                                <img style={{height: 25}} src="/images/chaos.png"/>&nbsp;{formatNumber(chaos)}
                            </Nav.Item>
                            <Nav.Item className="d-flex align-items-center me-3 text-light">
                                <img style={{height: 25}} src="/images/chaos.png"/>&nbsp;per
                                Click: {formatNumber(chaosPerClick)}
                            </Nav.Item>
                            <Nav.Item className="d-flex align-items-center me-3 text-light">
                                <img style={{height: 25}} src="/images/chaos.png"/>&nbsp;per
                                second: {formatNumber(helpersIncomePerSecond)}
                            </Nav.Item>
                            <Button className="my-3" variant="danger" onClick={upgradeClickValue}>
                                Upgrade <img style={{height: 25}} src="/images/chaos.png"/> (+1) -
                                Cost: {formatNumber(chaosPerClick * 100)}&nbsp;<img style={{height: 20}}
                                                                                    src="/images/chaos.png"/>
                            </Button>
                        </Nav>
                        <Nav>
                            <Button variant="secondary" onClick={() => setShowResetModal(true)}>
                                <i className="bi bi-arrow-clockwise"></i> Reset Game
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <div
                className="flex-grow-1 position-relative overflow-hidden clickable-area"
                style={{cursor: 'pointer'}}
                onClick={handleClick}
            >
                {helpers.map((helper) =>
                    helper.positions.map((position, index) => (
                        <img
                            key={`${helper.id}-${index}`}
                            src={helper.image}
                            alt={helper.name}
                            className="position-absolute helper pixel-art"
                            style={{
                                left: `${position.x}%`,
                                top: `${position.y}%`,
                                zIndex: Math.floor(10 + position.y),
                                transform: 'translate(-50%, -50%)',
                            }}
                        />
                    ))
                )}
                {helperAnimations.map((animation) => (
                    <div
                        key={animation.id}
                        className="position-absolute"
                        style={{
                            left: animation.x,
                            top: animation.y,
                            animation: 'fadeOut 1s forwards',
                            color: animation.color,
                            fontSize: '16px',
                            fontWeight: 'bold',
                        }}
                    >
                        +{formatNumber(animation.value)}
                    </div>
                ))}
                {clickAnimations.map((animation) => (
                    <div
                        key={animation.id}
                        className="position-absolute"
                        style={{
                            left: animation.x,
                            top: animation.y,
                            animation: 'fadeOut 1s forwards',
                            color: animation.color,
                            fontSize: '20px',
                            fontWeight: 'bold',
                        }}
                    >
                        +{formatNumber(animation.value)}
                    </div>
                ))}
            </div>

            <Button
                variant="danger"
                className="position-fixed bottom-0 start-0 w-100"
                onClick={toggleFooter}
                style={{zIndex: 1000}}
            >
                {isFooterVisible ? 'Hide Helpers' : 'Show Helpers'}
            </Button>

            <footer
                className={`bg-dark text-light p-2 d-flex flex-wrap justify-content-center ${isFooterVisible ? 'footer-visible' : 'footer-hidden'}`}
            >
                {helpers.map((helper) => (
                    <Button
                        key={helper.id}
                        variant="secondary"
                        size="sm"
                        className="m-1"
                        onClick={() => buyHelper(helper)}
                    >
                        <b>{helper.name}</b> Cost: {formatNumber(helper.cost)}&nbsp;<img style={{height: 20}}
                                                                                         src="/images/chaos.png"
                                                                                         alt="Chaos"/>
                    </Button>
                ))}
            </footer>

            <Modal show={showResetModal} onHide={() => setShowResetModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Reset Game</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to reset your progress? This action cannot be undone!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowResetModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={resetGame}>
                        Reset
                    </Button>
                </Modal.Footer>
            </Modal>

            <style jsx global>{`
                body {
                    user-select: none;
                }

                img {
                    pointer-events: none;
                }

                .pixel-art {
                    width: 80px;
                    height: 80px;
                    image-rendering: pixelated;
                }

                .clickable-area {
                    padding-bottom: 50px;
                }

                .footer-hidden {
                    transform: translateY(100%);
                }

                .footer-visible {
                    transform: translateY(0);
                }

                footer {
                    position: fixed;
                    bottom: 50px;
                    left: 0;
                    width: 100%;
                    transition: transform 0.3s ease-in-out;
                    z-index: 999;
                }

                @keyframes fadeOut {
                    0% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                    100% {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                }
            `}</style>
        </div>
    );
}

export default App;
